export default __webpack_public_path__ + "static/media/nodejs-svgrepo-com.9a54ea2c.svg";